import Dexie from "dexie";
import db from "../Db";

var DeleteGnUtil = Dexie.async(function* () {
  yield db.open();
  yield db.GNUTIL.clear();
});

export default DeleteGnUtil;
